export default __webpack_public_path__ + "assets/media/star.b823d916.png";